import { render } from "./PetWeight.vue?vue&type=template&id=79557df4&scoped=true"
import script from "./PetWeight.vue?vue&type=script&lang=js"
export * from "./PetWeight.vue?vue&type=script&lang=js"

import "./PetWeight.vue?vue&type=style&index=0&id=79557df4&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79557df4"]])

export default __exports__